
export interface FilePath {
  name: string;
  path: string;
  type?: string;
  size: number;
}

interface FileLike extends Blob {
  readonly name: string;
  path?: string;
}

export type FileApi = FileLike | FilePath;

export function isFileApi(obj: Partial<File & FilePath>): obj is FileApi {
  return obj.name != null && obj.size != null;
}

